import {imageSortByWeight} from '../utils/product/product-helpers.js';
import {computed, nextTick} from 'vue';
import store from '@/store';

export function usePrepareProductImages(product, selectedVariantCode) {
  const selectedColor = computed(() => store.state.productDetails.selectedColor);
  const selectedAttribute = computed(() => store.state.productDetails.selectedAttribute);

  store.commit('productDetails/setIsUpdatingProductImages', true);
  let imageKey;
  if (selectedColor.value) {
    imageKey = selectedColor.value;
  } else if (selectedAttribute.value && product.variantAttributesDirectory[0].type === 'radio') {
    imageKey = product.variantAttributesDirectory[0].options.find(
      (option) => option.value === selectedAttribute.value
    )?.value;
  } else if (selectedAttribute.value) {
    imageKey = product.variantAttributesDirectory[0].options.find(
      (option) => option.value === selectedAttribute.value
    )?.colorSwatchName;
  } else {
    imageKey = Object.keys(product.images)[0];
  }

  let images = product.images[imageKey]?.filter((item) => item.variantList.includes(selectedVariantCode));

  images = imageSortByWeight(images);

  const mediaType = (type, data) => {
    return data?.flatMap((item) => {
      return {
        type,
        productType: product?.productType,
        assetId: item?.stillAssetId ? item.stillAssetId : item.assetId,
        ...item,
      };
    });
  };

  const imageTypes = mediaType('image', images);
  const videoTypes = mediaType('video', product?.videos);
  const concatTypes = [
    ...(imageTypes?.length
      ? imageTypes
      : [
          {
            accessorized: false,
            type: 'image',
            assetId: 'default-no-image',
            variantList: [selectedVariantCode],
            weight: 10,
          },
        ]),
    ...(videoTypes?.length ? videoTypes : []),
  ];
  store.commit('productDetails/setImages', concatTypes);
  nextTick(() => {
    store.commit('productDetails/setIsUpdatingProductImages', false);
  });
}
